let transacaoId: string | undefined;

export const setTransacaoId = (id: string): void => {
    transacaoId = id;
};

export const getTransacaoId = (): string | undefined => transacaoId;
